<template>
  <div>
    <div style="width: 100%">
      <div style="height: 50px" class="livehead"></div>
    </div>
    <v-container class="text-center">
      <div class="text-center">
        <v-img style="display: inline-block" width="200px" src="../assets/mitsuicon.png"></v-img>
      </div>
      <div class="mt-5 px-9">
        <v-row justify="center">
          <v-col class="pa-0" lg="3">
            <v-text-field
              dense
              filled
              v-model="input.username"
              outlined
              placeholder="Username"
            ></v-text-field
          ></v-col>
        </v-row>
        <v-row justify="center">
          <v-col class="pa-0" lg="3">
            <v-text-field
              dense
              filled
              v-model="input.password"
              outlined
              placeholder="Password"
            ></v-text-field
          ></v-col>
        </v-row>
        <v-row justify="center">
          <div class="text-center">
            <v-checkbox color="red" v-model="rememberme" label="Remember me"></v-checkbox>
          </div>
        </v-row>
        <div>
          <v-btn :loading="loading" @click="signin" color="rgb(227 38 51)" depressed dark
            >Sign in</v-btn
          >
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: {
        username: '',
        password: ''
      },
      loading: false,
      rememberme: false
    }
  },
  beforeCreate() {
    this.$store.state.bgcolor = '#efefef'
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },

  methods: {
    signin() {
      // this.loading = true;
      if (this.rememberme) {
        localStorage.setItem(
          'user',
          JSON.stringify({
            username: this.input.username,
            password: this.input.password,
            remember: this.rememberme
          })
        )
      }
      this.$store.state.user = this.input
      this.$router.push('Livechat')
    }
  }
}
</script>

<style lang="scss" scoped>
.livehead {
  background-color: #b3202a;
  color: white;
  padding: 13px;
}
</style>
